import { Flex, Text } from '@approvalmax/ui/src/components';
import { domain } from 'modules/data';
import { FC, memo } from 'react';

import { messages } from './AuditReportStatusIndicator.messages';
import { StyledBigAlertIcon, StyledReportInProgressIcon } from './AuditReportStatusIndicator.styles';
import { AuditReportStatusIndicatorProps } from './AuditReportStatusIndicator.types';

const AuditReportStatusIndicator: FC<AuditReportStatusIndicatorProps> = memo((props) => {
    const { auditReportStatus } = props;

    return (
        <Flex alignItems='center' justifyContent='center' direction='column' height='100%'>
            <Text font='headline' textAlign='center' fontSize='xsmall' fontWeight='medium'>
                {auditReportStatus === domain.RequestAuditReportStatus.Pending &&
                    messages.auditReportPendingText({ br: <br /> })}

                {auditReportStatus === domain.RequestAuditReportStatus.Error && messages.auditReportGenerationError}

                {auditReportStatus === domain.RequestAuditReportStatus.ConnectionError &&
                    messages.auditReportConnectionError}
            </Text>

            {auditReportStatus === domain.RequestAuditReportStatus.Pending && (
                <StyledReportInProgressIcon width={75} height={70} />
            )}

            {(auditReportStatus === domain.RequestAuditReportStatus.Error ||
                auditReportStatus === domain.RequestAuditReportStatus.ConnectionError) && (
                <StyledBigAlertIcon width={60} height={60} />
            )}
        </Flex>
    );
});

export default AuditReportStatusIndicator;
